import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import baseURL from '../component/baseURL';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { ReactNotifications } from 'react-notifications-component';
import showNotification from '../component/Notification';
import ProfilePopup from '../component/ProfilePopup';
export default function DetailsPage() {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [userid, setUserid] = useState('');
    const [agentKey, setAgentkey] = useState('');
    const [agentID, setAgentID] = useState('');
    const [listingID, setListingID] = useState('');
    const [otherResult, setOtherResult] = useState('');
    const [infoCardResult, setInfoCardResult] = useState([]);
    const [listingImage, setListingImage] = useState('');
    const [portfolioImages, setPortfolioImages] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [propertyType, setPropertyType] = useState('');
    const [publicRemarks, setPublicRemarks] = useState('');
    const [standardStatus, setStandardStatus] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        console.log('portfolioImages state updated:', portfolioImages);
    }, [portfolioImages]);
    useEffect(() => {

        const userID = localStorage.getItem('userID');
        setUserid(userID);
        const agentKey = localStorage.getItem('agentKey');
        setAgentkey(agentKey);
        const agentid = localStorage.getItem('agentID');
        setAgentID(agentid);
        const listingid = location.state.listingID;
        setListingID(listingid);

        fetchDetailsAPI(userID, agentid, listingid);

        // Add class to body when component mounts
        document.body.classList.add('details-page');

        // Initialize Fancybox
        Fancybox.bind('[data-fancybox="gallery"]', {
            Toolbar: {
                display: {
                    left: ["infobar"],
                    middle: [],
                    right: ["slideshow", "download", "thumbs", "close"],
                },
            },
            Thumbs: {
                autoStart: false,
            },
            Carousel: {
                infinite: true,
            },
        });

        // Remove class when component unmounts
        return () => {
            document.body.classList.remove('details-page');
            Fancybox.unbind('[data-fancybox="gallery"]');
            Fancybox.close();
        };

    }, []);


    const formatPrice = (price) => {
        if (price === null || price === undefined) {
            return '';
        }

        const priceString = price.toString();
        const match = priceString.match(/^(\D*)(\d+)(.*)$/);

        if (!match) {
            return priceString;
        }

        const [, prefix, digits, suffix] = match;
        const formattedDigits = digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return `${prefix}${formattedDigits}${suffix}`;
    };

    const handleThumbnailClick = (index) => {
        setCurrentImageIndex(index);
        setListingImage(portfolioImages[index].imagename);
    };

    const handlePrevClick = () => {
        if (portfolioImages.length > 0) {
            const newIndex = currentImageIndex === 0 ? portfolioImages.length - 1 : currentImageIndex - 1;
            setCurrentImageIndex(newIndex);
            setListingImage(portfolioImages[newIndex].imagename);
        }
    };

    const handleNextClick = () => {
        if (portfolioImages.length > 0) {
            const newIndex = currentImageIndex === portfolioImages.length - 1 ? 0 : currentImageIndex + 1;
            setCurrentImageIndex(newIndex);
            setListingImage(portfolioImages[newIndex].imagename);
        }
    };

    const getImageSrc = (img) => img.imagename ?? img.image_name ?? img.image ?? img.url;

    const openGalleryFancybox = (startIndex = 0) => {
        if (portfolioImages.length === 0) return;
        const images = portfolioImages.map(img => ({ src: getImageSrc(img) }));
        Fancybox.show(images, {
            startIndex,
            Toolbar: {
                display: {
                    left: ["infobar"],
                    middle: [],
                    right: ["slideshow", "download", "thumbs", "close"],
                },
            },
            Thumbs: { autoStart: false },
            Carousel: { infinite: true },
        });
    };

    const handleExpandClick = () => {
        openGalleryFancybox(currentImageIndex);
    };



    function fetchDetailsAPI(userID, agentid, listingid) {
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        formdata.append("listing_id", listingid)
        formdata.append("type", 'consumer')
        formdata.append("agent_id", agentid)
        console.log(formdata)
        fetch(baseURL.URL + '/portfolio/portfolio_details', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                const res = responseJson.response
                const filterPresent = res?.filter?.present ?? res?.filter?.[0]?.present
                const present = filterPresent ?? res?.present ?? res
                const agentResult = present?.agent_details
                const otherResult = present
                const infoCardShown = Array.isArray(present?.info_card_shown) ? present.info_card_shown : []
                const infoCardResult = infoCardShown
                const myData = []
                if (responseJson.server?.code === 200 && otherResult) {
                    const statusEntry = infoCardShown.find(item => item.field_name === 'StandardStatus')
                    const statusValue = statusEntry ? (statusEntry.field_value ?? statusEntry.data?.[0] ?? '') : (otherResult.StandardStatus ?? '')
                    setStandardStatus(typeof statusValue === 'string' ? statusValue.trim() : String(statusValue || ''))
                    for (let i = 0; i < infoCardResult.length; i++) {
                        if (infoCardResult[i].field_name_label !== 'BedroomsTotal' && infoCardResult[i].field_name_label !== 'ListPrice'
                            && infoCardResult[i].field_name_label !== 'StreetNumber' && infoCardResult[i].field_name_label !== 'StreetName'
                            && infoCardResult[i].field_name_label !== 'StandardStatus' && infoCardResult[i].field_name_label !== 'City'
                            && infoCardResult[i].field_name_label !== 'BathroomsTotalInteger' && infoCardResult[i].field_name_label !== 'PostalCode'
                            && infoCardResult[i].field_name_label !== 'GarageSpaces' && infoCardResult[i].field_name_label !== 'ParkingTotal'
                            && infoCardResult[i].field_name_label !== 'SurfaceArea' && infoCardResult[i].field_name_label !== 'SurfaceAreaUnit'
                            && infoCardResult[i].field_name_label !== 'PropertyType'
                        ) {

                            myData.push(infoCardResult[i])
                        }

                        if (infoCardResult[i].field_name_label == 'PropertyType') {
                            // this.setState({ propertyType: infoCardResult[i].field_value })
                            setPropertyType(infoCardResult[i].field_value)
                        }
                        if (infoCardResult[i].field_name_label == 'ListingId') {
                            // this.setState({ listingIDName: infoCardResult[i].field_value })
                        }
                        else if (infoCardResult[i].field_name_label == 'PublicRemarks') {

                            var alphabet = infoCardResult[i].field_value
                            if (alphabet && typeof alphabet === 'string' && alphabet.includes('<iframe')) {
                                setPublicRemarks(alphabet.replace(/<iframe.*iframe>/, ''))
                            }

                            console.log("ALPHABET : *****************");
                            console.log(alphabet.replace(/<iframe.*iframe>/, ''))

                            // this.setState({ public_remarks: infoCardResult[i].field_value })
                            //Alert.alert(infoCardResult[i].field_value)
                        }

                    }

                    setOtherResult(otherResult);
                    setInfoCardResult(myData);

                    // Set portfolio images – use API array as-is; resolve relative URLs with base from API
                    const rawImgArray = present?.portfolio_img ?? res?.filter?.present?.portfolio_img ?? res?.filter?.[0]?.portfolio_img ?? [];
                    const imgList = Array.isArray(rawImgArray) ? rawImgArray : [];
                    const imageBase = (present?.base_url || present?.images_path || 'https://www.yesmls.com').replace(/\/$/, '');
                    const toImageUrl = (url) => {
                        if (!url || typeof url !== 'string') return url;
                        const u = url.trim();
                        if (u.startsWith('http://') || u.startsWith('https://')) return u;
                        return u.startsWith('/') ? imageBase + u : imageBase + '/' + u;
                    };
                    if (imgList.length > 0) {
                        setPortfolioImages(imgList);
                        const first = imgList[0];
                        const firstUrlRaw = typeof first === 'string'
                            ? first
                            : (first.imagename ?? first.image_name ?? first.image ?? first.url ?? '');
                        setListingImage(toImageUrl(firstUrlRaw));
                        setCurrentImageIndex(0);

                        // Reinitialize Fancybox after images are loaded
                        setTimeout(() => {
                            Fancybox.unbind('[data-fancybox="gallery"]');
                            Fancybox.bind('[data-fancybox="gallery"]', {
                                Toolbar: {
                                    display: {
                                        left: ["infobar"],
                                        middle: [],
                                        right: ["slideshow", "download", "thumbs", "close"],
                                    },
                                },
                                Thumbs: {
                                    autoStart: false,
                                },
                                Carousel: {
                                    infinite: true,
                                },
                            });
                        }, 100);
                    } else {
                        setListingImage('https://www.yesmls.com/yes100/assets/images/no-listing-image.png');
                        setPortfolioImages([]);
                    }
                    setIsLoading(false);
                    // this.setState({
                    //     Price: '€ ' + otherResult.list_price, AgentFname: agentResult.member_fname, AgentLname: agentResult.member_lname, Status: otherResult.StandardStatus, ProfileImage: agentResult.agent_image,
                    //     CompanyImage: agentResult.company_image, City: otherResult.city_name, StreetName: otherResult.StreetName, StreetNumber: otherResult.StreetNumber, PostalCode: otherResult.PostalCode, fav: otherResult.is_favorite,
                    //     BedRoom: otherResult.BedroomsTotal, Bathroom: otherResult.BathroomsTotalInteger, Garage: otherResult.GarageSpaces, Parking: otherResult.ParkingTotal, DATA: myData, livingArea: otherResult.LivingArea, livingAreaUnit: otherResult.LivingAreaUnits,

                    // })
                    console.log("CHECK**********************");
                    console.log(otherResult.PropertyType);
                }
                else {
                    console.error('API Error:', responseJson.server.message);
                    setIsLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    }


    function askInfoApi() {
        // this.setState({ isLoading: true })
        // const { navigate } = this.props.navigation;
        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        formdata.append("listing_id", listingID)
        formdata.append("agent_key", agentKey)
        console.log(formdata);
        fetch(baseURL.URL + '/consumer_portfolio/ask_info', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                console.log('ASK INFO API ******************')
                console.log(responseJson);
                if (responseJson.server.result_code == 200) {
                    //   this.setState({ isLoading: false })
                    //   Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                    showNotification('Success', responseJson.server.message, 'success');
                    setTimeout(() => { fetchDetailsAPI(userid, agentID, listingID) }, 50)
                } else {
                    //   this.setState({ isLoading: false })
                    //   Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                    showNotification('Error', responseJson.server.message, 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }


    function makeFav(listingId) {
        if (!listingId || !userid || !agentID || !otherResult) {
            console.warn('Missing data to mark favorite', { listingId, userid, agentID, otherResult });
            return;
        }

        // Get current favorite status and toggle it
        const currentFavoriteStatus = otherResult.is_favorite;
        const newFavoriteStatus = currentFavoriteStatus === '1' || currentFavoriteStatus === 1 ? '0' : '1';

        // Optimistically update the state
        setOtherResult({
            ...otherResult,
            is_favorite: newFavoriteStatus
        });

        // Show notification based on favorite status
        if (newFavoriteStatus === '1') {
            showNotification('Success', 'Added to favorites', 'success');
        } else {
            showNotification('Success', 'Removed from favorites', 'success');
        }

        const formdata = new FormData();
        formdata.append("user_id", userid);
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055');
        formdata.append("listing_id", listingId);
        formdata.append("agent_id", agentID);
        formdata.append("is_favorite", newFavoriteStatus);

        fetch(baseURL.URL + '/consumer_portfolio/listing_favorites', {
            method: 'POST',
            body: formdata
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server.code !== 200) {
                    // Revert the optimistic update on error
                    setOtherResult({
                        ...otherResult,
                        is_favorite: currentFavoriteStatus
                    });
                    showNotification('Error', responseJson.server.message || 'Unable to update favorite', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                // Revert the optimistic update on error
                setOtherResult({
                    ...otherResult,
                    is_favorite: currentFavoriteStatus
                });
                showNotification('Error', 'Something went wrong while updating favorite', 'danger');
            });
    }

    return (
        <>
            <ReactNotifications />
            <main className="main-content">
                <div className="container">
                    {isLoading ? (
                        <div className='loading-filters' style={{
                            textAlign: 'center',
                            padding: '60px 20px',
                            color: '#666',
                            height: '100vh',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                width: '50px',
                                height: '50px',
                                border: '4px solid #f3f3f3',
                                borderTop: '4px solid #1C4CAF',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                margin: '0 auto 20px'
                            }}></div>
                            <h3 style={{ fontSize: '24px', marginBottom: '10px', color: '#333' }}>{t('loading')}</h3>
                            <p style={{ fontSize: '16px', color: '#999' }}>{t('pleaseWaitWhileWeFetchThePropertyDetails')}</p>
                        </div>
                    ) : (
                        <>
                            <div className="back-btn" aria-label="Back" onClick={() => navigate(-1)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M12.5 15L7.5 10L12.5 5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <section className="details-layout">
                                <div className="layout-left">
                                    <section className="details-gallery">
                                        <div className="gallery-left">

                                            <button
                                                className={`favorite-btn ${otherResult && (otherResult.is_favorite === '1' || otherResult.is_favorite === 1) ? 'active' : ''}`}
                                                aria-label="Favorite"
                                                onClick={() => makeFav(listingID)}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                                                    <path d="M0 5.85219C0 10.7151 4.01943 13.3065 6.96173 15.626C8 16.4445 9 17.2151 10 17.2151C11 17.2151 12 16.4445 13.0383 15.626C15.9806 13.3065 20 10.7151 20 5.85219C20 0.98925 14.4998 -2.45945 10 2.21572C5.50016 -2.45945 0 0.98925 0 5.85219Z" fill="white" />
                                                </svg>
                                            </button>
                                            <div className="status">
                                                {standardStatus === 'Active' && (
                                                    <>
                                                        <span className="status-dot active"></span>
                                                        <span>{standardStatus}</span>
                                                    </>
                                                )}
                                                {standardStatus === 'Coming Soon' && (
                                                    <>
                                                        <span className="status-dot coming-soon"></span>
                                                        <span>{standardStatus}</span>
                                                    </>
                                                )}
                                                {standardStatus === 'Sold' && (
                                                    <>
                                                        <span className="status-dot sold"></span>
                                                        <span>{standardStatus}</span>
                                                    </>
                                                )}
                                                {standardStatus === 'Cancelled' && (
                                                    <>
                                                        <span className="status-dot cancelled"></span>
                                                        <span>{standardStatus}</span>
                                                    </>
                                                )}
                                                {standardStatus === 'Under Offer' && (
                                                    <>
                                                        <span className="status-dot under-offer"></span>
                                                        <span>{standardStatus}</span>
                                                    </>
                                                )}
                                                {(!standardStatus || !['Active', 'Coming Soon', 'Sold', 'Cancelled', 'Under Offer'].includes(standardStatus)) && (
                                                    <>
                                                        <span className="status-dot"></span>
                                                        <span>{standardStatus || 'N/A'}</span>
                                                    </>
                                                )}
                                            </div>
                                            {portfolioImages.length > 1 && (
                                                <>
                                                    <button className="gallery-prev" aria-label="Previous" onClick={handlePrevClick}>
                                                        <i className="fa-solid fa-chevron-left"></i>
                                                    </button>
                                                    <button className="gallery-next" aria-label="Next" onClick={handleNextClick}>
                                                        <i className="fa-solid fa-chevron-right"></i>
                                                    </button>
                                                </>
                                            )}
                                            <a
                                                href={listingImage}
                                                data-fancybox="gallery"
                                                data-index={currentImageIndex}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleExpandClick();
                                                }}
                                                style={{ display: 'block', width: '100%', height: '100%' }}
                                            >
                                                <img
                                                    className="gallery-main"
                                                    src={listingImage || undefined}
                                                    alt="Property main"
                                                    referrerPolicy="no-referrer"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = 'https://www.yesmls.com/yes100/assets/images/no-listing-image.png';
                                                    }}
                                                />
                                            </a>
                                            {/* <button className="gallery-expand" aria-label="Expand" onClick={handleExpandClick}><i className="fa-solid fa-up-right-and-down-left-from-center"></i></button> */}
                                        </div>
                                        {portfolioImages && portfolioImages.length > 0 && (
                                            <div className="gallery-right gallery-right--single">
                                                <div
                                                    className={`thumb ${portfolioImages.length > 1 ? 'more' : ''}`}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        openGalleryFancybox(0);
                                                    }}
                                                    aria-label="View all images"
                                                    role="button"
                                                    tabIndex={0}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            openGalleryFancybox(0);
                                                        }
                                                    }}
                                                >
                                                    <img
                                                        src={getImageSrc(portfolioImages[0])}
                                                        alt="Gallery thumbnail"
                                                        referrerPolicy="no-referrer"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = 'https://www.yesmls.com/yes100/assets/images/no-listing-image.png';
                                                        }}
                                                    />
                                                    {portfolioImages.length > 1 && (
                                                        <span className="more-count">+{portfolioImages.length - 1}</span>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </section>
                                    <section className="summary-left">
                                        <div className="summary-card">
                                            <div className="summary-header">
                                                <div className="summary-title-group">
                                                    <h2 className="summary-title">{otherResult.PostalCode} {otherResult.city_name}</h2>
                                                    <div className="summary-location">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                            <path d="M10.0001 1.81818C6.49118 1.81818 3.63647 4.47669 3.63647 7.74444C3.63647 11.7998 9.33131 17.7533 9.57377 18.0048C9.80151 18.241 10.1991 18.2406 10.4265 18.0048C10.6689 17.7533 16.3637 11.7998 16.3637 7.74444C16.3637 4.47669 13.509 1.81818 10.0001 1.81818ZM10.0001 10.7261C8.23468 10.7261 6.79844 9.38854 6.79844 7.74444C6.79844 6.10034 8.23472 4.7628 10.0001 4.7628C11.7655 4.7628 13.2017 6.10037 13.2017 7.74447C13.2017 9.38857 11.7655 10.7261 10.0001 10.7261Z" fill="black" fill-opacity="0.35" />
                                                        </svg>
                                                        <span>{otherResult.address}</span>
                                                    </div>
                                                </div>
                                                <div className="summary-price-group">
                                                    <div className="summary-price">€ {formatPrice(otherResult.list_price)}</div>
                                                    <div className="summary-type">{propertyType}</div>
                                                </div>
                                            </div>

                                            <div className="summary-features">
                                                <div className="feature">
                                                    <div className="feature-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                            <g clip-path="url(#clip0_405_733)">
                                                                <path d="M9.68521 11.0902L2.66029 7.27238C2.34781 7.10264 1.97881 7.10965 1.67304 7.29142C1.36727 7.47314 1.18481 7.794 1.18481 8.14972V17.0062C1.18481 17.3645 1.37832 17.6972 1.68985 17.8743L8.7149 21.868C8.86977 21.956 9.03911 22 9.20851 22C9.38112 22 9.55369 21.9543 9.71062 21.863C10.0214 21.6822 10.207 21.3595 10.207 20.9999V11.9676C10.207 11.6013 10.0071 11.2651 9.68521 11.0902Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M19.5402 4.96845C19.5397 4.59451 19.3332 4.25534 19.0012 4.08328L11.3408 0.111819C11.0507 -0.0386167 10.705 -0.0374991 10.416 0.114613L2.86825 4.08608C2.53961 4.25908 2.33519 4.59721 2.33472 4.96862C2.33429 5.33994 2.53789 5.67855 2.86606 5.85228L10.4139 9.84854C10.56 9.92587 10.7205 9.96455 10.881 9.96455C11.0396 9.96455 11.1982 9.92681 11.3429 9.8513L19.0035 5.85512C19.335 5.68216 19.5407 5.34239 19.5402 4.96845Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M20.3267 7.2914C20.0211 7.10963 19.6519 7.10245 19.3395 7.27232L12.3144 11.0902C11.9926 11.2651 11.7927 11.6013 11.7927 11.9675V20.9998C11.7927 21.3594 11.9783 21.6821 12.2891 21.8629C12.446 21.9543 12.6185 21.9999 12.7912 21.9999C12.9605 21.9999 13.13 21.9559 13.2848 21.8679L20.3099 17.8742C20.6214 17.6971 20.8149 17.3645 20.8149 17.0061V8.1497C20.8149 7.79398 20.6324 7.47313 20.3267 7.2914Z" fill="black" fill-opacity="0.35" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_405_733">
                                                                    <rect width="22" height="22" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                    <div className="feature-info">
                                                        <div className="feature-label">{t('dimension')}</div>
                                                        <div className="feature-value">{otherResult.LivingArea ?? otherResult.living_area ?? 'N/A'} {(otherResult.LivingAreaUnits || otherResult.living_area_unit) === "Sq Meter" ? "m" : "f"}<sup className=''>2</sup></div>
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                            <g clip-path="url(#clip0_405_741)">
                                                                <path d="M2.47178 13.9166V6.1042C2.47178 5.5634 2.03338 5.125 1.49263 5.125C0.951828 5.125 0.513428 5.5634 0.513428 6.1042V18.8958C0.513428 19.4366 0.951828 19.875 1.49263 19.875C2.03338 19.875 2.47178 19.4366 2.47178 18.8958V17.0614L22.5282 17.0142V18.8487C22.5282 19.3895 22.9666 19.8279 23.5074 19.8279C24.0481 19.8279 24.4865 19.3895 24.4865 18.8487V17.0142V14.4529V13.8695L2.47178 13.9166Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M24.4865 13.0779H9.60107V9.39035C9.60107 8.3203 10.4685 7.45285 11.5386 7.45285H20.575C22.7353 7.45285 24.4865 9.20405 24.4865 11.3643V13.0779Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M6.11706 12.656C7.4373 12.656 8.50756 11.5857 8.50756 10.2655C8.50756 8.94526 7.4373 7.875 6.11706 7.875C4.79683 7.875 3.72656 8.94526 3.72656 10.2655C3.72656 11.5857 4.79683 12.656 6.11706 12.656Z" fill="black" fill-opacity="0.35" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_405_741">
                                                                    <rect width="25" height="25" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                    <div className="feature-info">
                                                        <div className="feature-label">{t('bedrooms')}</div>
                                                        <div className="feature-value">{otherResult.BedroomsTotal}</div>
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                            <g clip-path="url(#clip0_405_749)">
                                                                <path d="M3.10162 23.8612C2.87721 24.1978 2.96818 24.6526 3.30475 24.8769C3.42965 24.9602 3.57076 25 3.71036 25C3.94703 25 4.17931 24.8855 4.32042 24.6737L4.87863 23.8364C4.42677 23.6381 3.99625 23.3999 3.59205 23.1255L3.10162 23.8612Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M21.4082 23.1255C21.004 23.3999 20.5735 23.6381 20.1216 23.8364L20.6798 24.6737C20.8209 24.8855 21.0531 25 21.2898 25C21.4294 25 21.5706 24.9602 21.6955 24.8769C22.0321 24.6526 22.123 24.1978 21.8986 23.8612L21.4082 23.1255Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M1.51367 14.1671V16.4551C1.51367 20.0898 4.47075 23.0469 8.10547 23.0469H16.8945C20.5292 23.0469 23.4863 20.0898 23.4863 16.4551V16.0286H11.3839C7.97895 16.0286 4.6646 15.4025 1.51367 14.1671Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M3.95483 8.63228V2.68555C3.95483 2.01245 4.50244 1.46484 5.17554 1.46484H6.1521C6.8252 1.46484 7.3728 2.01245 7.3728 2.68555V3.03306C6.24058 3.35928 5.41968 4.42187 5.41968 5.65601V5.85938C5.41968 6.26387 5.74761 6.5918 6.1521 6.5918H10.0583C10.4628 6.5918 10.7908 6.26387 10.7908 5.85938V5.61523C10.7908 4.38833 9.96348 3.35156 8.83765 3.03188V2.68555C8.83765 1.20474 7.63291 0 6.1521 0H5.17554C3.69473 0 2.48999 1.20474 2.48999 2.68555V8.04414C2.60532 8.07959 2.71919 8.12124 2.83096 8.1708C3.20249 8.33594 3.57725 8.4895 3.95483 8.63228Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M23.3947 11.451H11.384C8.21198 11.451 5.13517 10.7979 2.23776 9.5101C1.45095 9.16156 0.53244 9.51469 0.183368 10.2999C-0.165705 11.0852 0.187909 12.0053 0.973211 12.3543C4.2714 13.8205 7.77375 14.5638 11.3841 14.5638H23.3948C24.2546 14.5638 24.9512 13.8671 24.9512 13.0074C24.9511 12.1476 24.2545 11.451 23.3947 11.451Z" fill="black" fill-opacity="0.35" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_405_749">
                                                                    <rect width="25" height="25" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                    <div className="feature-info">
                                                        <div className="feature-label">{t('bathrooms')}</div>
                                                        <div className="feature-value">{otherResult.BathroomsTotalInteger}</div>
                                                    </div>
                                                </div>
                                                <div className="feature">
                                                    <div className="feature-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                            <path d="M3.12492 20.5448V21.875C3.12492 22.1512 3.23467 22.4162 3.43001 22.6116C3.62537 22.8069 3.89031 22.9167 4.16659 22.9167H5.20825C5.48452 22.9167 5.74947 22.8069 5.94483 22.6116C6.14017 22.4162 6.24992 22.1512 6.24992 21.875V20.8333H18.7499V21.875C18.7499 22.1512 18.8597 22.4162 19.055 22.6116C19.2503 22.8069 19.5153 22.9167 19.7916 22.9167H20.8333C21.1095 22.9167 21.3745 22.8069 21.5698 22.6116C21.7651 22.4162 21.8749 22.1512 21.8749 21.875V20.5448C22.191 20.3635 22.4537 20.1022 22.6365 19.7871C22.8194 19.4721 22.916 19.1143 22.9166 18.75V15.625C22.9166 14.7594 22.3885 14.0187 21.6374 13.7031L20.2124 9.42812C20.0058 8.8057 19.608 8.26426 19.0761 7.88073C18.5441 7.4972 17.9047 7.29107 17.2489 7.29166H7.75096C7.09512 7.29107 6.45576 7.4972 5.92375 7.88073C5.39174 8.26426 4.99414 8.8057 4.78742 9.42812L3.36242 13.7031C2.98356 13.8618 2.66003 14.1288 2.43245 14.4708C2.20488 14.8127 2.08339 15.2143 2.08325 15.625V18.75C2.08325 19.5187 2.50409 20.1833 3.12492 20.5448ZM5.72909 18.75C5.52383 18.7499 5.3206 18.7095 5.13098 18.6308C4.94138 18.5522 4.76911 18.437 4.62401 18.2919C4.33099 17.9986 4.16645 17.601 4.16659 17.1865C4.16672 16.7719 4.33153 16.3744 4.62475 16.0813C4.91797 15.7883 5.31559 15.6238 5.73013 15.6239C6.14467 15.6241 6.54217 15.7888 6.8352 16.0821C7.12822 16.3753 7.29276 16.7729 7.29263 17.1875C7.29249 17.6021 7.12768 17.9996 6.83446 18.2926C6.54124 18.5856 6.14363 18.7501 5.72909 18.75ZM19.2708 18.75C18.8562 18.7499 18.4587 18.5851 18.1656 18.2919C17.8726 17.9986 17.7081 17.601 17.7083 17.1865C17.7084 16.7719 17.8731 16.3744 18.1664 16.0813C18.4596 15.7883 18.8572 15.6238 19.2718 15.6239C19.6864 15.6241 20.0839 15.7888 20.3769 16.0821C20.6699 16.3753 20.8344 16.7729 20.8343 17.1875C20.8342 17.6021 20.6694 17.9996 20.3762 18.2926C20.0829 18.5856 19.6853 18.7501 19.2708 18.75ZM7.75096 9.37499H17.2478C17.4666 9.37494 17.6797 9.44373 17.8572 9.57162C18.0346 9.6995 18.1673 9.87999 18.2364 10.0875L19.3885 13.5417H5.61138L6.76242 10.0875C6.90513 9.66145 7.30304 9.37499 7.75096 9.37499Z" fill="black" fill-opacity="0.35" />
                                                            <path d="M22.9166 7.69585V5.49898L12.8291 2.13648C12.6062 2.06186 12.3645 2.06516 12.1437 2.14586L2.08325 5.80419V8.02085L12.5155 4.22711L22.9166 7.69585Z" fill="black" fill-opacity="0.35" />
                                                        </svg>
                                                    </div>
                                                    <div className="feature-info">
                                                        <div className="feature-label">{t('garage')}</div>
                                                        <div className="feature-value">{otherResult.GarageSpaces}</div>
                                                    </div>
                                                </div>
                                                <div className="feature no-border">
                                                    <div className="feature-icon">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                            <g clip-path="url(#clip0_328_541)">
                                                                <path d="M17.7288 10.8302C17.6483 10.8302 17.5658 10.8417 17.4832 10.8644L16.5501 11.1214L15.5813 8.76108C15.3067 8.09242 14.4953 7.54834 13.7725 7.54834H4.70446C3.98159 7.54834 3.17028 8.09242 2.89581 8.76108L1.92819 11.1181L1.00661 10.8643C0.924142 10.8416 0.84158 10.8301 0.761128 10.8301C0.320065 10.8301 0 11.167 0 11.6311V12.1812C0 12.7229 0.44088 13.1638 0.982669 13.1638H1.08826L0.931848 13.5448C0.676824 14.1659 0.469226 15.2177 0.469226 15.8894V20.5784C0.469226 21.1202 0.910107 21.5611 1.4519 21.5611H2.73527C3.27706 21.5611 3.71794 21.1202 3.71794 20.5784V19.4075H14.7589V20.5784C14.7589 21.1202 15.1998 21.5611 15.7416 21.5611H17.0248C17.5666 21.5611 18.0075 21.1202 18.0075 20.5784V15.8895C18.0075 15.2179 17.7999 14.166 17.5448 13.5449L17.3884 13.1639H17.5071C18.0489 13.1639 18.4898 12.723 18.4898 12.1813V11.6312C18.4899 11.1671 18.1697 10.8302 17.7288 10.8302ZM2.63262 12.6302L4.09837 9.06005C4.26258 8.66008 4.75061 8.33277 5.18296 8.33277H13.294C13.7264 8.33277 14.2144 8.65999 14.3786 9.06005L15.8443 12.6302C16.0085 13.0302 15.7891 13.3575 15.3568 13.3575H3.12029C2.68785 13.3574 2.46851 13.0302 2.63262 12.6302ZM5.90455 17.1461C5.90455 17.3623 5.72759 17.5391 5.51155 17.5391H2.7272C2.51098 17.5391 2.33411 17.3622 2.33411 17.1461V15.8098C2.33411 15.5937 2.51098 15.4168 2.7272 15.4168H5.51155C5.72759 15.4168 5.90455 15.5937 5.90455 15.8098V17.1461ZM16.1164 17.1461C16.1164 17.3623 15.9395 17.5391 15.7234 17.5391H12.9391C12.7231 17.5391 12.5461 17.3622 12.5461 17.1461V15.8098C12.5461 15.5937 12.7231 15.4168 12.9391 15.4168H15.7234C15.9395 15.4168 16.1164 15.5937 16.1164 15.8098V17.1461Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M24.373 3.43872H19.7188C19.0411 3.43872 18.4897 3.99014 18.4897 4.66779V9.32208C18.4897 9.99982 19.0412 10.5512 19.7188 10.5512H21.5872V20.9973C21.5872 21.2507 21.7925 21.456 22.0459 21.456C22.2992 21.456 22.5045 21.2507 22.5045 20.9973V10.5513H24.373C25.0508 10.5513 25.6021 9.99991 25.6021 9.32217V4.66788C25.6021 3.99014 25.0508 3.43872 24.373 3.43872ZM23.3189 7.29775C23.0512 7.53874 22.6569 7.66093 22.1471 7.66093H21.4731C21.3922 7.66093 21.3263 7.72689 21.3263 7.8078V8.94431C21.3263 9.06779 21.2258 9.16814 21.1024 9.16814H20.592C20.4684 9.16814 20.368 9.06769 20.368 8.94431V5.04602C20.368 4.92245 20.4685 4.822 20.592 4.822H21.8777C22.7295 4.822 23.0474 4.95034 23.3087 5.17206C23.5843 5.40589 23.7239 5.76403 23.7239 6.23674C23.7238 6.69863 23.5877 7.05548 23.3189 7.29775Z" fill="black" fill-opacity="0.35" />
                                                                <path d="M22.5892 5.76322C22.4648 5.66928 22.2447 5.62158 21.9352 5.62158H21.4729C21.392 5.62158 21.3262 5.68745 21.3262 5.76827V6.70232C21.3262 6.78314 21.392 6.849 21.4729 6.849H21.7499C21.8516 6.849 22.016 6.84148 22.1163 6.83221C22.2136 6.82332 22.4884 6.7835 22.5892 6.70736C22.7102 6.61581 22.7716 6.45747 22.7716 6.23685C22.7716 6.01412 22.7102 5.85477 22.5892 5.76322Z" fill="black" fill-opacity="0.35" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_328_541">
                                                                    <rect width="25" height="25" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </div>
                                                    <div className="feature-info">
                                                        <div className="feature-label">{t('parking')}</div>
                                                        <div className="feature-value">{otherResult.ParkingTotal}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>

                                <aside className="contact-right">
                                    <div className="contact-card">
                                        <div className='content-holder'>
                                            <h3 className="contact-title">{otherResult.PostalCode} {otherResult.city_name}</h3>
                                            <div className="contact-location">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M10.0001 1.81818C6.49118 1.81818 3.63647 4.47669 3.63647 7.74444C3.63647 11.7998 9.33131 17.7533 9.57377 18.0048C9.80151 18.241 10.1991 18.2406 10.4265 18.0048C10.6689 17.7533 16.3637 11.7998 16.3637 7.74444C16.3637 4.47669 13.509 1.81818 10.0001 1.81818ZM10.0001 10.7261C8.23468 10.7261 6.79844 9.38854 6.79844 7.74444C6.79844 6.10034 8.23472 4.7628 10.0001 4.7628C11.7655 4.7628 13.2017 6.10037 13.2017 7.74447C13.2017 9.38857 11.7655 10.7261 10.0001 10.7261Z" fill="black" fill-opacity="0.35" />
                                                </svg>
                                                <span>{otherResult.address}</span>
                                            </div>
                                            <div className="contact-fields">
                                                {infoCardResult.map((cardList, idx) => (
                                                    <div className="field-holder" key={cardList.field_name_label ?? idx}>
                                                        {
                                                            cardList.field_name_label == "PublicRemarks" ?
                                                                // <div className='grid-item text-left pub_remark'>
                                                                //     <p className='font-semibold text-2xl'>Publ</p>
                                                                //     <p className='text-base font-light'>{cardList.field_value}</p>
                                                                // </div>
                                                                null
                                                                :
                                                                <div className='grid-item text-left flex w-full justify-between'>
                                                                    <p className='font-light text-base opacity-80 field-label'>{cardList.field_name_label.replace(/([a-z0-9])([A-Z])/g, "$1 $2")}</p>

                                                                    {
                                                                        cardList.field_value === null || cardList.field_value === undefined ?
                                                                            <p className='text-base font-bold field-value'>N/A</p> :
                                                                            (typeof cardList.field_value === 'string' ? cardList.field_value.trim() : cardList.field_value) === "" ?
                                                                                <p className='text-base font-bold'>N/A</p>
                                                                                : <p className='text-base font-bold field-value'>{typeof cardList.field_value === 'string' ? cardList.field_value.trim() : cardList.field_value}</p>

                                                                    }

                                                                </div>
                                                        }
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                        <button className="btn-primary contact-cta" onClick={() => askInfoApi()}>{t('askInformation')}</button>
                                    </div>



                                </aside>
                            </section>
                        </>
                    )}
                </div>
            </main>
            <ProfilePopup />
        </>
    );
}